import { render, staticRenderFns } from "./SingleDocHubResourceViewer.vue?vue&type=template&id=f459a96c"
import script from "./SingleDocHubResourceViewer.vue?vue&type=script&lang=js"
export * from "./SingleDocHubResourceViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports